import { render, staticRenderFns } from "./filter-chip-group.vue?vue&type=template&id=3d0bcc46&scoped=true"
import script from "./filter-chip-group.vue?vue&type=script&lang=js"
export * from "./filter-chip-group.vue?vue&type=script&lang=js"
import style0 from "./filter-chip-group.vue?vue&type=style&index=0&id=3d0bcc46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0bcc46",
  null
  
)

export default component.exports